import { useEffect, useState } from "react";
import { HandHeart } from "@/lib/icons";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
const replyCls = { thanks: "bg-emerald-100 text-emerald-800", okay: "bg-sky-100 text-sky-800", hard_week: "bg-rose-100 text-rose-800" };

export function NudgeHistory({ clientId }) {
  const [d, setD] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => { setD(null); api.get(`/clinician/client/${clientId}/nudges`).then((r) => setD(r.data)); }, [clientId]);
  if (!d) return null;
  const shown = all ? d.items : d.items.slice(0, 6);
  return (
    <section className="warm-card p-6" data-testid="nudge-history">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <div className="flex items-center gap-2"><HandHeart className="w-5 h-5 text-amber-700" /><h3 className="font-display text-lg font-bold text-stone-900">Nudges & replies</h3></div>
        <div className="text-xs text-stone-500 font-mono" data-testid="nudge-history-stats">{d.sent} sent · {d.replied} replied{d.hard_weeks ? ` · ${d.hard_weeks} hard week${d.hard_weeks === 1 ? "" : "s"}` : ""}</div>
      </div>
      {d.items.length === 0 && <p className="text-sm text-stone-500" data-testid="nudge-history-empty">No nudges yet. When a member goes quiet, the "nudge" button in the member list sends a gentle note — replies land here.</p>}
      <ol className="relative border-l border-stone-200 ml-2 space-y-4">
        {shown.map((n) => (
          <li key={n.id} className="ml-4" data-testid={`nudge-history-item-${n.id}`}>
            <span className={`absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full ${n.reply ? "bg-amber-600" : n.read ? "bg-stone-400" : "bg-stone-200"}`} />
            <div className="text-[11px] text-stone-500 font-mono">{fmt(n.sent_at)} · you nudged{n.read && !n.reply ? " · seen" : ""}</div>
            <div className="text-sm text-stone-800 mt-0.5">“{n.message}”</div>
            {n.reply && (
              <div className="mt-1.5 inline-flex flex-wrap items-center gap-1.5 text-xs">
                <span className={`font-semibold px-2 py-0.5 rounded-full ${replyCls[n.reply]}`}>↩ {n.reply_label}</span>
                {n.reply_note && <span className="italic text-stone-600">“{n.reply_note}”</span>}
                <span className="text-stone-400">{fmt(n.replied_at)}</span>
              </div>
            )}
          </li>
        ))}
      </ol>
      {d.items.length > 6 && <button onClick={() => setAll((v) => !v)} data-testid="nudge-history-toggle" className="mt-3 text-xs font-semibold text-amber-800">{all ? "Show recent only" : `Show all ${d.items.length}`}</button>}
    </section>
  );
}
